<template>
  <div class="StepIndicator" :class="cc">
    <div v-if="!onboardingTheme" v-show="id !== steps" class="Line" />
  </div>
</template>

<script>
export default {
  name: 'StepIndicator',
  props: {
    id: {
      type: Number,
      required: true
    },
    steps: {
      type: Number,
      required: true
    },
    currentStep: {
      type: Number,
      required: true
    },
    onboardingTheme: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cc() {
      return [
        {'is-last': this.id === this.steps},
        {'is-active': this.id === this.currentStep},
        {'is-complete': this.id < this.currentStep},
        {'is-onboarding': this.onboardingTheme}
      ]
    }
  }
}
</script>

<style scoped>
.StepIndicator {
  @apply relative w-4 h-4 rounded-full bg-gray-200 mr-2 border-3 border-gray-200;
  &.is-last {
    margin-right: 0 !important;
  }
  &.is-active {
    @apply border-gray-900 bg-white;
  }
  &.is-complete {
    @apply border-gray-900 bg-gray-900;
    .Line {
      @apply bg-gray-900;
    }
  }
  &.is-onboarding {
    width: 10px;
    height: 10px;
    @apply mr-2 bg-gray-300 border-none;
    &.is-active {
      @apply bg-accent;
    }
  }
}
.StepIndicator .Line {
  @apply absolute w-2 h-3px bg-gray-200;
  top: 4px;
  left: 13px;
}
@media (min-width: 480px) {
  .StepIndicator {
    @apply mr-6;
    .Line {
      @apply w-6;
    }
  }
}
</style>
